import { useEffect } from "react";

/**
 * The Jardin Secret landing page lives as a pure HTML/CSS/JS bundle in
 * /app/static_site/ (also mirrored to /app/frontend/public/site/ so the
 * preview server can serve it).
 *
 * This React shell simply redirects the root URL to that static site so the
 * preview environment reflects the deliverable exactly as it will run on the
 * user's Docker VPS / Cloud Panel.
 */
function App() {
  useEffect(() => {
    window.location.replace("/site/index.html");
  }, []);

  return (
    <div
      data-testid="redirect-shell"
      style={{
        minHeight: "100vh",
        background: "#06040a",
        color: "#e9c87a",
        fontFamily: "serif",
        display: "grid",
        placeItems: "center",
        letterSpacing: "0.3em",
        textTransform: "uppercase",
        fontSize: "0.8rem",
      }}
    >
      <a
        href="/site/index.html"
        style={{ color: "#e9c87a", textDecoration: "none" }}
        data-testid="redirect-link"
      >
        Entrer dans le Jardin Secret →
      </a>
    </div>
  );
}

export default App;
